import React from 'react';
import { useIntl } from 'react-intl';
import { IconButton, Tooltip } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// The leaf component Trips uses through the index: importing it directly avoids loading the range/time pickers.
import DatePicker from 'Components/uiControls/DatePicker/DatePicker';
import { dateToDayKey, dayKeyToDate } from '../utils/calendar';

// The same picker Trips uses in the map: the app's DatePicker opened inline in a floating menu
// (`datepicker_container--slider`), with only the days with activity enabled, plus the previous/next arrows.
export const DayPicker = ({ days, dayKey, hasPrev, hasNext, onStep, onPick }) => {
  const { formatMessage } = useIntl();
  const prevLabel = formatMessage({ id: 'requestVideo_day_prev' });
  const nextLabel = formatMessage({ id: 'requestVideo_day_next' });

  const pick = (date) => {
    if (date) onPick(dateToDayKey(date));
  };

  return (
    <div className="request-video-day-picker">
      <DatePicker
        className="datepicker_container--slider"
        value={dayKeyToDate(dayKey)}
        maxDate={dayKeyToDate(days[days.length - 1])}
        onChange={pick}
        disabledDates={days.map(dayKeyToDate)}
        inline
      />
      <Tooltip title={prevLabel}>
        <span>
          <IconButton size="small" disabled={!hasPrev} aria-label={prevLabel} onClick={() => onStep(-1)}>
            <ChevronLeftIcon />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={nextLabel}>
        <span>
          <IconButton size="small" disabled={!hasNext} aria-label={nextLabel} onClick={() => onStep(1)}>
            <ChevronRightIcon />
          </IconButton>
        </span>
      </Tooltip>
    </div>
  );
};
